import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useState } from "react";

function DailyReportDateSelect({ setParentDate, loaded }) {
  const [date, setDate] = useState(dayjs(new Date()));
  const oneDayMs = 1000 * 60 * 60 * 24;
  const daysRange = 7;
  let minDate = dayjs(new Date() - oneDayMs * daysRange);

  const handler = (val) => {
    setDate(val);
    setParentDate(val);
  };

  useEffect(() => {
    loaded(true);
  }, []);

  return (
    <DatePicker
      format="DD-MM-YYYY"
      label="Report del giorno"
      disableFuture
      // minDate={minDate}
      value={date}
      onChange={(newVal) => handler(newVal)}
    />
  );
}

export default DailyReportDateSelect;
